<template>
  <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnRefreshVisible="false" @refresh="onRefresh">
    <template slot="toolbar-title">
      <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
    </template>
    <template slot="table-body">
      <rsa-paziente-attivita-obiettivi-component :idAccettazione="idAccettazione"></rsa-paziente-attivita-obiettivi-component>
    </template>
  </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteAttivitaObiettiviComponent from "../components/RsaPazienteAttivitaObiettiviComponent.vue";

export default {
  props: {
    utente: { type: Object },
  },
  components: {
    SaPageLayout,
    RsaOspiteAnagraficaComponent,
    RsaPazienteAttivitaObiettiviComponent,
  },
  data() {
    return {
      idAccettazione: null,
      linkback: "/rsagestioneospiti",
      linkedit: null,
      jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
      pathResource: null,
      pathResourceAccettazione: "/accettazioni",
      showModalLoading: false,
      listKey: 0,
    };
  },
  created() {
    this.idAccettazione = this.$route.query.idAccettazione;
  },
  mounted() {
    let me = this;

    me.loadAccettazione();
  },
  methods: {
    loadAccettazione() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
      axios
        .get(link)
        .then((response) => {
          me.jsonData = response.data.data;
          me.$refs.cmpRsaPazienteRefertoListComponent.loadData(me.idAccettazione);
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },

    onRefresh() {
      let me = this;
      me.$refs.cmpRsaPazienteRefertoListComponent.loadData();
    },
  },
};
</script>
